export { default as AddSquareBold } from "./AddSquareBold";
export { default as AddSquareRegular } from "./AddSquareRegular";
export { default as AlertBold } from "./AlertBold";
export { default as AlertRegular } from "./AlertRegular";
export { default as AnnounceBold } from "./AnnounceBold";
export { default as AnnounceRegular } from "./AnnounceRegular";
export { default as Apartment2Bold } from "./Apartment2Bold";
export { default as Apartment2Regular } from "./Apartment2Regular";
export { default as ApartmentBold } from "./ApartmentBold";
export { default as ApartmentRegular } from "./ApartmentRegular";
export { default as ArrowDownBold } from "./ArrowDownBold";
export { default as ArrowDownCircleBold } from "./ArrowDownCircleBold";
export { default as ArrowDownCircleRegular } from "./ArrowDownCircleRegular";
export { default as ArrowDownLeftBold } from "./ArrowDownLeftBold";
export { default as ArrowDownLeftRegular } from "./ArrowDownLeftRegular";
export { default as ArrowDownRegular } from "./ArrowDownRegular";
export { default as ArrowDownRightBold } from "./ArrowDownRightBold";
export { default as ArrowDownRightRegular } from "./ArrowDownRightRegular";
export { default as ArrowLeftBold } from "./ArrowLeftBold";
export { default as ArrowLeftCircleBold } from "./ArrowLeftCircleBold";
export { default as ArrowLeftCircleRegular } from "./ArrowLeftCircleRegular";
export { default as ArrowLeftDownCircleBold } from "./ArrowLeftDownCircleBold";
export { default as ArrowLeftDownCircleRegular } from "./ArrowLeftDownCircleRegular";
export { default as ArrowLeftRegular } from "./ArrowLeftRegular";
export { default as ArrowLeftUpCircleBold } from "./ArrowLeftUpCircleBold";
export { default as ArrowLeftUpCircleRegular } from "./ArrowLeftUpCircleRegular";
export { default as ArrowRightBold } from "./ArrowRightBold";
export { default as ArrowRightCircleBold } from "./ArrowRightCircleBold";
export { default as ArrowRightCircleRegular } from "./ArrowRightCircleRegular";
export { default as ArrowRightDownCircleBold } from "./ArrowRightDownCircleBold";
export { default as ArrowRightDownCircleRegular } from "./ArrowRightDownCircleRegular";
export { default as ArrowRightRegular } from "./ArrowRightRegular";
export { default as ArrowRightUpCircleBold } from "./ArrowRightUpCircleBold";
export { default as ArrowRightUpCircleRegular } from "./ArrowRightUpCircleRegular";
export { default as ArrowTrendingDownBold } from "./ArrowTrendingDownBold";
export { default as ArrowTrendingDownRegular } from "./ArrowTrendingDownRegular";
export { default as ArrowTrendingUpBold } from "./ArrowTrendingUpBold";
export { default as ArrowTrendingUpRegular } from "./ArrowTrendingUpRegular";
export { default as ArrowUpBold } from "./ArrowUpBold";
export { default as ArrowUpCircleBold } from "./ArrowUpCircleBold";
export { default as ArrowUpCircleRegular } from "./ArrowUpCircleRegular";
export { default as ArrowUpLeftBold } from "./ArrowUpLeftBold";
export { default as ArrowUpLeftRegular } from "./ArrowUpLeftRegular";
export { default as ArrowUpRegular } from "./ArrowUpRegular";
export { default as ArrowUpRightBold } from "./ArrowUpRightBold";
export { default as ArrowUpRightRegular } from "./ArrowUpRightRegular";
export { default as AtRegular } from "./AtRegular";
export { default as BadgeBold } from "./BadgeBold";
export { default as BadgeRegular } from "./BadgeRegular";
export { default as BagBold } from "./BagBold";
export { default as BagCheckBold } from "./BagCheckBold";
export { default as BagCheckRegular } from "./BagCheckRegular";
export { default as BagRegular } from "./BagRegular";
export { default as BankBold } from "./BankBold";
export { default as BankRegular } from "./BankRegular";
export { default as BikeBold } from "./BikeBold";
export { default as BikeRegular } from "./BikeRegular";
export { default as Bolt2Bold } from "./Bolt2Bold";
export { default as Bolt2Regular } from "./Bolt2Regular";
export { default as Bookmark1Bold } from "./Bookmark1Bold";
export { default as Bookmark1Regular } from "./Bookmark1Regular";
export { default as Bookmark2Bold } from "./Bookmark2Bold";
export { default as Bookmark2Regular } from "./Bookmark2Regular";
export { default as BuildingRegular } from "./BuildingRegular";
export { default as BulbBold } from "./BulbBold";
export { default as BulbRegular } from "./BulbRegular";
export { default as BurgerMenuBold } from "./BurgerMenuBold";
export { default as BurgerMenuRegular } from "./BurgerMenuRegular";
export { default as CalculatorBold } from "./CalculatorBold";
export { default as CalculatorRegular } from "./CalculatorRegular";
export { default as CalenderBold } from "./CalenderBold";
export { default as CalenderRegular } from "./CalenderRegular";
export { default as CameraBold } from "./CameraBold";
export { default as CameraRegular } from "./CameraRegular";
export { default as CancelCallBold } from "./CancelCallBold";
export { default as CarAddBold } from "./CarAddBold";
export { default as CarAddRegular } from "./CarAddRegular";
export { default as CarBold } from "./CarBold";
export { default as CarMinusBold } from "./CarMinusBold";
export { default as CarMinusRegular } from "./CarMinusRegular";
export { default as CarRegular } from "./CarRegular";
export { default as CarSeat } from "./CarSeat";
export { default as CardBold } from "./CardBold";
export { default as CardRegular } from "./CardRegular";
export { default as CartBold } from "./CartBold";
export { default as CartRegular } from "./CartRegular";
export { default as CashBold } from "./CashBold";
export { default as CashRegular } from "./CashRegular";
export { default as CertificateBold } from "./CertificateBold";
export { default as CertificateRegular } from "./CertificateRegular";
export { default as ChatBubbleBold } from "./ChatBubbleBold";
export { default as ChatBubbleDotsBold } from "./ChatBubbleDotsBold";
export { default as ChatBubbleDotsRegular } from "./ChatBubbleDotsRegular";
export { default as ChatBubbleGroupBold } from "./ChatBubbleGroupBold";
export { default as ChatBubbleGroupRegular } from "./ChatBubbleGroupRegular";
export { default as ChatBubbleLikeBold } from "./ChatBubbleLikeBold";
export { default as ChatBubbleLikeRegular } from "./ChatBubbleLikeRegular";
export { default as ChatBubbleReadBold } from "./ChatBubbleReadBold";
export { default as ChatBubbleReadRegular } from "./ChatBubbleReadRegular";
export { default as ChatBubbleRegular } from "./ChatBubbleRegular";
export { default as CheckSquareBold } from "./CheckSquareBold";
export { default as CheckSquareRegular } from "./CheckSquareRegular";
export { default as ChevronDownBold } from "./ChevronDownBold";
export { default as ChevronDownRegular } from "./ChevronDownRegular";
export { default as ChevronLeftBold } from "./ChevronLeftBold";
export { default as ChevronLeftRegular } from "./ChevronLeftRegular";
export { default as ChevronRightBold } from "./ChevronRightBold";
export { default as ChevronRightRegular } from "./ChevronRightRegular";
export { default as ChevronUpBold } from "./ChevronUpBold";
export { default as ChevronUpRegular } from "./ChevronUpRegular";
export { default as CityBold } from "./CityBold";
export { default as CityRegular } from "./CityRegular";
export { default as ClockBold } from "./ClockBold";
export { default as ClockRegular } from "./ClockRegular";
export { default as CloseSquareBold } from "./CloseSquareBold";
export { default as CloseSquareRegular } from "./CloseSquareRegular";
export { default as CompassBold } from "./CompassBold";
export { default as CompassRegular } from "./CompassRegular";
export { default as ContactsBold } from "./ContactsBold";
export { default as ContactsRegular } from "./ContactsRegular";
export { default as CopyBold } from "./CopyBold";
export { default as CopyRegular } from "./CopyRegular";
export { default as CrossBold } from "./CrossBold";
export { default as CrossCircleBold } from "./CrossCircleBold";
export { default as CrossCircleRegular } from "./CrossCircleRegular";
export { default as CrossRegular } from "./CrossRegular";
export { default as CupStarRegular } from "./CupStarRegular";
export { default as DirectionBold } from "./DirectionBold";
export { default as DirectionRegular } from "./DirectionRegular";
export { default as DoubleTickBold } from "./DoubleTickBold";
export { default as DoubleTickRegular } from "./DoubleTickRegular";
export { default as Download } from "./Download";
export { default as Edit2Bold } from "./Edit2Bold";
export { default as Edit2Regular } from "./Edit2Regular";
export { default as EditBold } from "./EditBold";
export { default as EditRegular } from "./EditRegular";
export { default as ExclaimationCircleBold } from "./ExclaimationCircleBold";
export { default as ExclaimationCircleRegular } from "./ExclaimationCircleRegular";
export { default as EyeBold } from "./EyeBold";
export { default as EyeClosedBold } from "./EyeClosedBold";
export { default as EyeClosedRegular } from "./EyeClosedRegular";
export { default as EyeRegular } from "./EyeRegular";
export { default as FileAddBold } from "./FileAddBold";
export { default as FileAddRegular } from "./FileAddRegular";
export { default as FileBold } from "./FileBold";
export { default as FileCheckBold } from "./FileCheckBold";
export { default as FileCheckRegular } from "./FileCheckRegular";
export { default as FileLockedBold } from "./FileLockedBold";
export { default as FileLockedRegular } from "./FileLockedRegular";
export { default as FilePdfBold } from "./FilePdfBold";
export { default as FilePdfRegular } from "./FilePdfRegular";
export { default as FileRegular } from "./FileRegular";
export { default as FileRemoveBold } from "./FileRemoveBold";
export { default as FileRemoveRegular } from "./FileRemoveRegular";
export { default as FileWarningBold } from "./FileWarningBold";
export { default as FileWarningRegular } from "./FileWarningRegular";
export { default as FilterBold } from "./FilterBold";
export { default as FilterRegular } from "./FilterRegular";
export { default as Flag2Bold } from "./Flag2Bold";
export { default as Flag2Regular } from "./Flag2Regular";
export { default as FlagBold } from "./FlagBold";
export { default as FlagRegular } from "./FlagRegular";
export { default as FlashBold } from "./FlashBold";
export { default as FlashRegular } from "./FlashRegular";
export { default as FolderBold } from "./FolderBold";
export { default as FolderRegular } from "./FolderRegular";
export { default as Fuel } from "./Fuel";
export { default as FuelDrop } from "./FuelDrop";
export { default as GPS } from "./GPS";
export { default as GarageBold } from "./GarageBold";
export { default as GarageRegular } from "./GarageRegular";
export { default as GateBold } from "./GateBold";
export { default as GateRegular } from "./GateRegular";
export { default as GiftBold } from "./GiftBold";
export { default as GiftRegular } from "./GiftRegular";
export { default as GiftTopBold } from "./GiftTopBold";
export { default as GiftTopRegular } from "./GiftTopRegular";
export { default as HeartBold } from "./HeartBold";
export { default as HeartRegular } from "./HeartRegular";
export { default as HelpAndSupport } from "./HelpAndSupport";
export { default as HistoryBold } from "./HistoryBold";
export { default as HistoryRegular } from "./HistoryRegular";
export { default as HomeBold } from "./HomeBold";
export { default as HomeRegular } from "./HomeRegular";
export { default as ImageBold } from "./ImageBold";
export { default as ImageRegular } from "./ImageRegular";
export { default as IncomingCallBold } from "./IncomingCallBold";
export { default as Info2CircleBold } from "./Info2CircleBold";
export { default as Info2CircleRegular } from "./Info2CircleRegular";
export { default as InfoCircleBold } from "./InfoCircleBold";
export { default as InfoCircleRegular } from "./InfoCircleRegular";
export { default as KebabMenuBold } from "./KebabMenuBold";
export { default as KebabMenuRegular } from "./KebabMenuRegular";
export { default as KeyBold } from "./KeyBold";
export { default as KeyRegular } from "./KeyRegular";
export { default as LikeRegular } from "./LikeRegular";
export { default as Link1Bold } from "./Link1Bold";
export { default as Link1Regular } from "./Link1Regular";
export { default as LocationBold } from "./LocationBold";
export { default as LocationRegular } from "./LocationRegular";
export { default as LockBold } from "./LockBold";
export { default as LockOpenBold } from "./LockOpenBold";
export { default as LockOpenRegular } from "./LockOpenRegular";
export { default as LockRegular } from "./LockRegular";
export { default as LogoutRegular } from "./LogoutRegular";
export { default as LongArrowDownBold } from "./LongArrowDownBold";
export { default as LongArrowDownRegular } from "./LongArrowDownRegular";
export { default as LongArrowLeftBold } from "./LongArrowLeftBold";
export { default as LongArrowLeftRegular } from "./LongArrowLeftRegular";
export { default as LongArrowRightBold } from "./LongArrowRightBold";
export { default as LongArrowRightRegular } from "./LongArrowRightRegular";
export { default as LongArrowUpBold } from "./LongArrowUpBold";
export { default as LongArrowUpRegular } from "./LongArrowUpRegular";
export { default as MailBold } from "./MailBold";
export { default as MailOpenBold } from "./MailOpenBold";
export { default as MailOpenRegular } from "./MailOpenRegular";
export { default as MailRegular } from "./MailRegular";
export { default as MeatballMenuBold } from "./MeatballMenuBold";
export { default as MeatballMenuCircleBold } from "./MeatballMenuCircleBold";
export { default as MeatballMenuCircleRegular } from "./MeatballMenuCircleRegular";
export { default as MeatballMenuRegular } from "./MeatballMenuRegular";
export { default as MedalStarBold } from "./MedalStarBold";
export { default as MedalStarRegular } from "./MedalStarRegular";
export { default as MessageBold } from "./MessageBold";
export { default as MessageDotsBold } from "./MessageDotsBold";
export { default as MessageDotsRegular } from "./MessageDotsRegular";
export { default as MessageGroupBold } from "./MessageGroupBold";
export { default as MessageGroupRegular } from "./MessageGroupRegular";
export { default as MessageLikeBold } from "./MessageLikeBold";
export { default as MessageLikeRegular } from "./MessageLikeRegular";
export { default as MessageReadBold } from "./MessageReadBold";
export { default as MessageReadRegular } from "./MessageReadRegular";
export { default as MessageRegular } from "./MessageRegular";
export { default as MicrophoneBold } from "./MicrophoneBold";
export { default as MicrophoneRegular } from "./MicrophoneRegular";
export { default as MinuBold } from "./MinuBold";
export { default as MinuRegular } from "./MinuRegular";
export { default as MinusCircleBold } from "./MinusCircleBold";
export { default as MinusCircleRegular } from "./MinusCircleRegular";
export { default as MinusSquareBold } from "./MinusSquareBold";
export { default as MinusSquareRegular } from "./MinusSquareRegular";
export { default as NavigateBold } from "./NavigateBold";
export { default as NavigateRegular } from "./NavigateRegular";
export { default as NotebookBold } from "./NotebookBold";
export { default as NotebookRegular } from "./NotebookRegular";
export { default as NotificationBold } from "./NotificationBold";
export { default as NotificationRegular } from "./NotificationRegular";
export { default as NotificationSilentBold } from "./NotificationSilentBold";
export { default as NotificationSilentRegular } from "./NotificationSilentRegular";
export { default as Offer2Bold } from "./Offer2Bold";
export { default as Offer2Regular } from "./Offer2Regular";
export { default as OfferBold } from "./OfferBold";
export { default as OfferRegular } from "./OfferRegular";
export { default as PaperclipBold } from "./PaperclipBold";
export { default as PaperclipRegular } from "./PaperclipRegular";
export { default as ParkVerifiedBold } from "./ParkVerifiedBold";
export { default as ParkVerifiedRegular } from "./ParkVerifiedRegular";
export { default as PhoneBold } from "./PhoneBold";
export { default as PhoneCalling } from "./PhoneCalling";
export { default as PhoneRegular } from "./PhoneRegular";
export { default as PlusBold } from "./PlusBold";
export { default as PlusCircleBold } from "./PlusCircleBold";
export { default as PlusCircleRegular } from "./PlusCircleRegular";
export { default as PlusRegular } from "./PlusRegular";
export { default as QrCodeBold } from "./QrCodeBold";
export { default as QrCodeRegular } from "./QrCodeRegular";
export { default as QuestionCircleBold } from "./QuestionCircleBold";
export { default as QuestionCircleRegular } from "./QuestionCircleRegular";
export { default as RefreshBold } from "./RefreshBold";
export { default as RefreshRegular } from "./RefreshRegular";
export { default as RestartBold } from "./RestartBold";
export { default as RestartRegular } from "./RestartRegular";
export { default as RestrictBold } from "./RestrictBold";
export { default as RestrictRegular } from "./RestrictRegular";
export { default as RocketBold } from "./RocketBold";
export { default as RocketRegular } from "./RocketRegular";
export { default as RoundDownArrowCircleBold } from "./RoundDownArrowCircleBold";
export { default as RoundDownArrowCircleRegular } from "./RoundDownArrowCircleRegular";
export { default as RoundLeftArrowCircleBold } from "./RoundLeftArrowCircleBold";
export { default as RoundLeftArrowCircleRegular } from "./RoundLeftArrowCircleRegular";
export { default as RoundRightArrowCircleBold } from "./RoundRightArrowCircleBold";
export { default as RoundRightArrowCircleRegular } from "./RoundRightArrowCircleRegular";
export { default as RoundUpArrowCircleBold } from "./RoundUpArrowCircleBold";
export { default as RoundUpArrowCircleRegular } from "./RoundUpArrowCircleRegular";
export { default as RupeeBold } from "./RupeeBold";
export { default as RupeeRegular } from "./RupeeRegular";
export { default as SearchBold } from "./SearchBold";
export { default as SearchCircleBold } from "./SearchCircleBold";
export { default as SearchCircleRegular } from "./SearchCircleRegular";
export { default as SearchRegular } from "./SearchRegular";
export { default as SendBold } from "./SendBold";
export { default as SendRegular } from "./SendRegular";
export { default as SettingsBold } from "./SettingsBold";
export { default as SettingsRegular } from "./SettingsRegular";
export { default as Share1Bold } from "./Share1Bold";
export { default as Share1Regular } from "./Share1Regular";
export { default as ShareBold } from "./ShareBold";
export { default as ShareMultipleBold } from "./ShareMultipleBold";
export { default as ShareMultipleRegular } from "./ShareMultipleRegular";
export { default as ShareRegular } from "./ShareRegular";
export { default as ShieldBold } from "./ShieldBold";
export { default as ShieldCheckBold } from "./ShieldCheckBold";
export { default as ShieldCheckRegular } from "./ShieldCheckRegular";
export { default as ShieldCrossBold } from "./ShieldCrossBold";
export { default as ShieldCrossRegular } from "./ShieldCrossRegular";
export { default as ShieldRegular } from "./ShieldRegular";
export { default as ShieldUserBold } from "./ShieldUserBold";
export { default as ShieldUserRegular } from "./ShieldUserRegular";
export { default as ShieldWarningBold } from "./ShieldWarningBold";
export { default as ShieldWarningRegular } from "./ShieldWarningRegular";
export { default as Shop1Bold } from "./Shop1Bold";
export { default as Shop1Regular } from "./Shop1Regular";
export { default as Shop2Bold } from "./Shop2Bold";
export { default as Shop2Regular } from "./Shop2Regular";
export { default as SortHorizontalBold } from "./SortHorizontalBold";
export { default as SortHorizontalRegular } from "./SortHorizontalRegular";
export { default as SortVerticleBold } from "./SortVerticleBold";
export { default as SortVerticleRegular } from "./SortVerticleRegular";
export { default as Speedometer } from "./Speedometer";
export { default as StackBold } from "./StackBold";
export { default as StackRegular } from "./StackRegular";
export { default as StarBold } from "./StarBold";
export { default as StarCircleBold } from "./StarCircleBold";
export { default as StarCircleRegular } from "./StarCircleRegular";
export { default as StarRegular } from "./StarRegular";
export { default as StarsBold } from "./StarsBold";
export { default as StarsRegular } from "./StarsRegular";
export { default as TickBold } from "./TickBold";
export { default as TickCircleBold } from "./TickCircleBold";
export { default as TickCircleRegular } from "./TickCircleRegular";
export { default as TickRegular } from "./TickRegular";
export { default as ToolBold } from "./ToolBold";
export { default as ToolRegular } from "./ToolRegular";
export { default as TransmissionLine } from "./TransmissionLine";
export { default as TrashBold } from "./TrashBold";
export { default as TrashRegular } from "./TrashRegular";
export { default as TrophyFirstBold } from "./TrophyFirstBold";
export { default as TrophyFirstRegular } from "./TrophyFirstRegular";
export { default as TrophyStarBold } from "./TrophyStarBold";
export { default as TrophyStarRegular } from "./TrophyStarRegular";
export { default as Upload } from "./Upload";
export { default as UserBold } from "./UserBold";
export { default as UserCheckBold } from "./UserCheckBold";
export { default as UserCheckRegular } from "./UserCheckRegular";
export { default as UserGroup1Bold } from "./UserGroup1Bold";
export { default as UserGroup1Regular } from "./UserGroup1Regular";
export { default as UserGroup2Bold } from "./UserGroup2Bold";
export { default as UserGroup2Regular } from "./UserGroup2Regular";
export { default as UserIdBold } from "./UserIdBold";
export { default as UserIdRegular } from "./UserIdRegular";
export { default as UserProfileBold } from "./UserProfileBold";
export { default as UserProfileRegular } from "./UserProfileRegular";
export { default as UserRegular } from "./UserRegular";
export { default as VerifiedCheckBold } from "./VerifiedCheckBold";
export { default as VerifiedCheckRegular } from "./VerifiedCheckRegular";
export { default as VideoBold } from "./VideoBold";
export { default as VideoRegular } from "./VideoRegular";
export { default as VolumeOffRegular } from "./VolumeOffRegular";
export { default as VolumeRegular } from "./VolumeRegular";
export { default as Whatsapp } from "./Whatsapp";
export { default as WhatsappIcon } from "./WhatsappIcon";
export { default as WidgetAddBold } from "./WidgetAddBold";
export { default as WidgetAddRegular } from "./WidgetAddRegular";
export { default as WidgetBold } from "./WidgetBold";
export { default as WidgetRegular } from "./WidgetRegular";
export { default as Like } from "./Like";
export { default as UpiRegular } from "./UpiRegular";
export { default as UpiBold } from "./UpiBold";
export { default as TicketRegular } from "./TicketRegular";
export { default as TicketBold } from "./TicketBold";
export { default as FoodRegular } from "./FoodRegular";
export { default as FoodBold } from "./FoodBold";
export { default as SecurityScanner } from "./SecurityScanner";
export { default as EssentialsRegular } from "./EssentialsRegular";
export { default as EssentialsBold } from "./EssentialsBold";
export { default as UserBlock } from "./UserBlock";
export { default as LikeBold } from './LikeBold'
export { default as UnlikeBold } from './UnlikeBold'
export { default as UnlikeRegular } from './UnlikeRegular'
export { default as DocumentBold } from './DocumentBold'
export { default as Document2Bold } from './Document2Bold'
export { default as ListRegular } from './ListRegular'